import React from "react";
import logo from "../../assets/img/header-logo.png"; // Adjust the path as needed

const Navbar = ({ scrollToConsult }) => {
  return (
    <header>
      <div className="row align-items-center bg-light fixed-top">
        <div className="col-lg-4"></div>
        <div className="d-flex justify-content-center col-lg-4" id="">
          <a className="animate__animated animate__zoomIn" href="/">
            <img src={logo} alt="Regent Dental Logo" height="70" />
          </a>
        </div>
        <div className="col-lg-4 d-flex justify-content-end pe-4">
          <div
            className="d-none d-lg-block cursor-pointer"
            onClick={scrollToConsult}
          >
            <button className="btn btn-golden animate__animated animate__slideInRight cursor-pointer">
              BOOK A FREE CONSULTATION
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
